import React, { useState } from "react";
import { Box, Container, Grid, Tab, Tabs } from "@mui/material";
import TabPanel, {
  tabPanelA11yProps
} from "../../../components/layout/TabPanel";
import {
  findGetParameter,
  newPath
} from "../../../components/utilities/UtilityFunctions";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";

import top5Players from "./demoData/top5Players.json";
import top5Countries from "./demoData/top5Countries.json";
import GroupHeader from "./components/GroupHeader";
import countries40k from "./demoData/countries40k.json";
import GroupTop5Box from "./components/GroupTop5Box";
import { isDev } from "../../../global/environmentVariables";
const IS_DEV = isDev();

const tabIndexes = {
  groups: 0,
  countries: 0,
  players: 1
};

const groups23 = {
  countries: [
    { label: "All Game Systems", key: "overall" },
    {
      eventId: IS_DEV ? "UJR73FGUF3" : "HM6LTF8BHK",
      label: "Warhammer 40,000",
      key: "40k",
      gameType: 1
    },
    {
      eventId: IS_DEV ? "JJU491TCKA" : "9B54BPJKA1",
      label: "Warhammer Age of Sigmar",
      key: "aos",
      gameType: 4
    },
    {
      eventId: IS_DEV ? "UJR73FGUF3" : "RP0H4V9KXX",
      label: "Warhammer 40,000: Kill Team",
      key: "kt",
      gameType: 26
    },
    {
      eventId: IS_DEV ? "NEKYHBPNC6" : "PRBR7C681R",
      label: "Warhammer Underworlds",
      key: "uw",
      gameType: 9
    }
  ],
  players: [
    {
      eventId: IS_DEV ? "UJR73FGUF3" : "HM6LTF8BHK",
      label: "Warhammer 40,000",
      key: "40k",
      gameType: 1
    },
    {
      eventId: IS_DEV ? "JJU491TCKA" : "9B54BPJKA1",
      label: "Warhammer Age of Sigmar",
      key: "aos",
      gameType: 4
    },
    {
      eventId: IS_DEV ? "UJR73FGUF3" : "RP0H4V9KXX",
      label: "Warhammer 40,000: Kill Team",
      key: "kt",
      gameType: 26
    },
    {
      eventId: IS_DEV ? "NEKYHBPNC6" : "PRBR7C681R",
      label: "Warhammer Underworlds",
      key: "uw",
      gameType: 9
    }
  ]
};

const groups24 = {
  countries: [
    { label: "All Game Systems", key: "overall" },
    {
      eventId: "ftaJF5FY6xAE",
      label: "Warhammer 40,000",
      key: "40k",
      gameType: 1
    },
    {
      eventId: "5X6ANRqrNNdc",
      label: "Warhammer Age of Sigmar",
      key: "aos",
      gameType: 4
    },
    {
      eventId: "isEnRfFp1VQN",
      label: "Warhammer 40,000: Kill Team",
      key: "kt",
      gameType: 26
    },
    {
      eventId: "7SSyWq7tLVaD",
      label: "Warhammer Underworlds",
      key: "uw",
      gameType: 9
    }
  ],
  players: [
    {
      eventId: "ftaJF5FY6xAE",
      label: "Warhammer 40,000",
      key: "40k",
      gameType: 1
    },
    {
      eventId: "5X6ANRqrNNdc",
      label: "Warhammer Age of Sigmar",
      key: "aos",
      gameType: 4
    },
    {
      eventId: "isEnRfFp1VQN",
      label: "Warhammer 40,000: Kill Team",
      key: "kt",
      gameType: 26
    },
    {
      eventId: "7SSyWq7tLVaD",
      label: "Warhammer Underworlds",
      key: "uw",
      gameType: 9
    }
  ]
};

const groups25 = {
  countries: [
    { label: "All Game Systems", key: "overall" },
    {
      eventId: "KhIQLAymD8Ay",
      label: "Warhammer 40,000",
      key: "40k",
      gameType: 1
    },
    {
      eventId: "RuF7lUi7LDvk",
      label: "Warhammer Age of Sigmar",
      key: "aos",
      gameType: 4
    },
    {
      eventId: "eFHc9v9gauiv",
      label: "Warhammer 40,000: Kill Team",
      key: "kt",
      gameType: 26
    },
    {
      eventId: "IaDn1zzGAq5b",
      label: "Warhammer Underworlds",
      key: "uw",
      gameType: 9
    }
  ],
  players: [
    {
      eventId: "KhIQLAymD8Ay",
      label: "Warhammer 40,000",
      key: "40k",
      gameType: 1
    },
    {
      eventId: "RuF7lUi7LDvk",
      label: "Warhammer Age of Sigmar",
      key: "aos",
      gameType: 4
    },
    {
      eventId: "eFHc9v9gauiv",
      label: "Warhammer 40,000: Kill Team",
      key: "kt",
      gameType: 26
    },
    {
      eventId: "IaDn1zzGAq5b",
      label: "Warhammer Underworlds",
      key: "uw",
      gameType: 9
    }
  ]
};

export default function GroupSummary({
  eventGroupId,
  groupName,
  groupNamePlural,
  label,
  appRoute
}) {
  const groups =
    eventGroupId === "WorldChamps25"
      ? groups25
      : eventGroupId === "WorldChamps24"
        ? groups24
        : groups23;
  const [loading, setLoading] = useState(true);
  const [groupSummary, setGroupSummary] = useState(null);
  const navigate = useNavigate();

  const activeTabParam = findGetParameter("active_tab");
  const embed = appRoute || findGetParameter("embed") === "true";

  const [activeTab, setActiveTab] = useState(
    activeTabParam
      ? tabIndexes[activeTabParam.toLowerCase()] !== undefined
        ? tabIndexes[activeTabParam.toLowerCase()]
        : 0
      : 0
  );
  const handleTabChange = async (e, newValue) => {
    setLoading(true);
    var path;
    Object.keys(tabIndexes).forEach((tabIndex) => {
      if (tabIndexes[tabIndex] === newValue) {
        path = newPath({
          active_tab: tabIndex
        });

        return true;
      }
    });
    setActiveTab(newValue);
    navigate(path, { replace: false });
    setLoading(false);
  };

  useEffect(() => {
    const go = async () => {
      setGroupSummary({
        overall: activeTab === 0 ? top5Countries : top5Players,
        "40k": activeTab === 0 ? countries40k : top5Players,
        aos: activeTab === 0 ? top5Countries : top5Players,
        kt: activeTab === 0 ? top5Countries : top5Players,
        uw: activeTab === 0 ? top5Countries : top5Players
      });
      setLoading(false);
    };
    go();
    // eslint-disable-next-line
  }, [activeTab]);

  if (loading) {
    return <ModalLoadingFull />;
  }

  const GroupSummaryTabPanel = () => (
    <Grid container spacing={1} sx={{ p: [1, 1, 2] }}>
      {groups[activeTab === 0 ? "countries" : "players"].map((group) => (
        <Grid key={`${activeTab}-${group.key}`} item xs={12} sm={6}>
          <GroupTop5Box
            eventGroupId={eventGroupId}
            eventId={group.eventId}
            groupNamePlural={activeTab === 0 ? "countries" : "players"}
            label={group.label}
            activeTab={activeTab}
            gameType={group.gameType}
            groupName={groupName || (activeTab === 0 ? "Country" : "Player")}
            groupData={groupSummary?.[group.key]}
          />
        </Grid>
      ))}
    </Grid>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ maxWidth: "100%" }}>
        <Container maxWidth="lg">
          <GroupHeader label={label} embed={embed} />
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth"
            scrollButtons="auto"
            aria-label="loyalty tabs"
          >
            <Tab
              label={groupNamePlural || "Countries"}
              {...tabPanelA11yProps(0)}
            />
            <Tab label="Players" {...tabPanelA11yProps(1)} />
          </Tabs>
        </Container>
      </Box>

      <Container
        maxWidth="lg"
        sx={{ pt: 2, pb: 2, backgroundColor: "background.secondary" }}
      >
        <TabPanel value={activeTab} index={0}>
          <GroupSummaryTabPanel />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <GroupSummaryTabPanel />
        </TabPanel>
      </Container>
    </Box>
  );
}
